module.exports = __webpack_public_path__ + "img/美国国家海洋和大气管理局.4f0daf2c.png";